
/*
 * All values are passed in a range of 0.0 to 1.0
 *
 * uniforms - stay the same for all points/pixels run through the shader.
 *
 * u_colorA and u_colorB 
 * are the gradient end point colors (there are always two colors passed)
 * Alpha values for each color will add weight to how intense the gradient is visible
 * To hide the gradient or color just 0.0 the alphas.
 *
 * u_colorApos u_colorBpos
 * are the positions/coordinates of the A and B color values (on a scale of 0-1) 
 * recommended: 
 *    A - x: 0.0, y: 0.0, 
 *    B - x: 1.0, y: 1.0
 * 
 */

import fragment from './twopointshader.glsl';

var TwoPointGradient = function (u_colorApos, u_colorBpos, u_colorA, u_colorB) {  

  u_colorApos = u_colorApos || [0.0,0.0];
  u_colorBpos = u_colorBpos || [1.0,1.0];

  u_colorA = u_colorA || [0.0,0.0,1.0,1.0];
  u_colorB = u_colorB || [1.0,0.0,0.5,1.0];

  PIXI.AbstractFilter.call(this, 
    // vertex shader
    null,
    // fragment shader
    [ fragment ],
    // custom unifroms
    {
      u_colorApos: { type: '2f', value: u_colorApos },
      u_colorBpos: { type: '2f', value: u_colorBpos },
      
      u_colorA: { type: '4f', value: u_colorA },
      u_colorB: { type: '4f', value: u_colorB },
      
    }
  );

};

TwoPointGradient.prototype = Object.create(PIXI.AbstractFilter.prototype);
TwoPointGradient.prototype.constructor = TwoPointGradient;

Object.defineProperties(TwoPointGradient.prototype, {

  u_colorA : {
    set: function (value) {
      this.uniforms.u_colorA.value = value;
      this.dirty = true;
    },
    get : function() {
      return this.uniforms.u_colorA.value;
    }
  },

  u_colorB : {
    set: function (value) {
      this.uniforms.u_colorB.value = value;
      this.dirty = true;
    },
    get : function() {
      return this.uniforms.u_colorB.value;
    }
  },

  u_colorApos : {
    set: function (value) {
      this.uniforms.u_colorApos.value = value;
      this.dirty = true;
    },
    get : function() {
      return this.uniforms.u_colorApos.value;
    }
  },

  u_colorBpos : {
    set: function (value) {
      this.uniforms.u_colorBpos.value = value;
      this.dirty = true;
    },
    get : function() {
      return this.uniforms.u_colorBpos.value;
    }
  }
});


module.exports = TwoPointGradient;


/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/twopointgradient.js
 **/